import React, { useEffect } from "react";
import { message, Form } from "antd";

import { useAppDispatch } from "redux/hooks";
import { createContact } from "redux/slice/faxSlice";
import { editContact } from "redux/slice/faxSlice";
import { useAuth0 } from "@auth0/auth0-react";
import { Input, Modal } from "components/ui-component";
import { ContactListType } from "components/fax/Contacts";

interface EditContactModalProps {
  isEdit: boolean;
  data: any;
  isOpen: boolean;
  closeModal: () => void;
  onYes: () => void;
}

const initialValues = {
  firstname: "",
  lastname: "",
  fax_number: "",
  notes: "",
};

const EditContactModal: React.FC<EditContactModalProps> = ({
  isOpen,
  closeModal,
  onYes,
  isEdit,
  data,
}) => {
  const [values, setValues] = React.useState(initialValues);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const { user } = useAuth0();
  const [form] = Form.useForm();

  const onSubmit = async (values: ContactListType) => {
    if (isEdit) {
      onUpdateCustomer({ ...values });
    } else {
      onCreateCustomer({ ...values });
    }
  };

  const onUpdateCustomer = async (formData: ContactListType) => {
    setIsLoading(true);
    try {
      const username = user?.email;
      let payload = { ...formData, id: data?.contact_id, username: username };

      const res: any = await dispatch(editContact(payload)).unwrap();

      if (res && res.status === "Error") {
        onYes();
        message.error("Falied to edit contact");
      } else {
        onYes();
        form.resetFields();
        message.success("Contact edited successfully");
      }
      setIsLoading(false);
    } catch (error: any) {
      console.log("edit sent fax err: --->", error?.message);
    }
  };

  const onCreateCustomer = async (values: any) => {
    setIsLoading(true);
    try {
      const payload = { ...values };
      const res: any = await dispatch(createContact(payload)).unwrap();
      if (res) {
        onYes();
        form.resetFields();
        setIsLoading(false);
        message.success("Contact created successfully");
      }
    } catch (error: any) {
      console.log("edit sent fax err: --->", error?.message);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    closeModal();
  };

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...data,
      });
      form.setFieldsValue({ ...data });
    } else {
      setValues(initialValues);
      form.setFieldsValue(initialValues);
    }
  }, [isEdit, data, form]);

  return (
    <Modal
      open={isOpen}
      title={isEdit ? "Edit Contact" : "Create Contact"}
      onCancel={() => handleCancel()}
      width={530}
      onOk={() => form.submit()}
      okText="Submit"
      isLoading={isLoading}
      className="edit-contact-modal"
      wrapClassName="edit-contact-modal-wrap"
    >
      <Form
        form={form}
        layout="horizontal"
        initialValues={values}
        onFinish={onSubmit}
        labelCol={{ span: 5 }}
      >
        <Form.Item label="First Name" name="firstname" labelAlign="left">
          <Input placeholder="Enter your First Name" />
        </Form.Item>
        <Form.Item label="Last Name" name="lastname" labelAlign="left">
          <Input placeholder="Enter your Last Name" />
        </Form.Item>
        <Form.Item
          labelAlign="left"
          label="Fax Number"
          name="fax_number"
          rules={[
            { required: true, message: "Please enter your Fax Number" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                if (value.charAt(0) === "0" || value.charAt(0) === "1") {
                  return Promise.reject(new Error("Fax number cannot start with 0 or 1."));
                }
                if (!/^\d*$/.test(value)) {
                  return Promise.reject(new Error("Only digits 0-9 are allowed."));
                }
                if (value.length > 10) {
                  return Promise.reject(new Error("Maximum 10 digits are allowed."));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Enter your Fax Number" />
        </Form.Item>
        <Form.Item label="Note" name="notes" labelAlign="left">
          <Input placeholder="Enter your Note" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditContactModal;
